import { CurrencyPipe } from "@angular/common";
import { Injectable } from "@angular/core";
import {AppLoggerService} from '@pmcretail/common-services/common/app-logger.service';

@Injectable({
  providedIn: "root",
})
export class NumberUtilService {
  className = "NumberUtilService";
  constructor( private cp: CurrencyPipe) {}

  trimTo2Decimal(no: number) {
    //return Math.floor(no * 100) / 100;
    return no;
  }

  trimTo2Decimal2(no: number) {
    // SEAM-11411 - Had to change 2nd param to 3 to fix rounding issue (FIXME - Needs a new story for refactoring)
    return Number(this.getFlooredFixed(no, 3));
  }

  getFlooredFixed(v, d) {
    return (Math.floor(v * Math.pow(10, d)) / Math.pow(10, d)).toFixed(d);
  }

  AppendWithCurrencySymbol(numValue: any, currencyCode: string): string {
    let returnValue: any = "";
    if (numValue) {
      const numb: number = parseFloat(numValue.toString().replace(',',''));
       returnValue = this.cp.transform(
       Number(numValue).toFixed(2),
        currencyCode.toLocaleUpperCase(),
        "symbol"
      );
      AppLoggerService.logDebug(this.className, "AppendWithCurrencySymbol", "AppendWithCurrencySymbol :" , returnValue);
    } else {
       returnValue = this.cp.transform(
        "0.00",
        currencyCode.toLocaleUpperCase(),
        "symbol"
      );
    }
    return returnValue;
  }
}
